module.exports = __webpack_public_path__ + "img/dot-pattern-2.b1ad1894.svg";